module.exports = __webpack_public_path__ + "static/media/enter-info.6c240d27.gif";